import { render, staticRenderFns } from "./HospitalNewDeparmentEdit.vue?vue&type=template&id=1423367a&"
import script from "./HospitalNewDeparmentEdit.vue?vue&type=script&lang=js&"
export * from "./HospitalNewDeparmentEdit.vue?vue&type=script&lang=js&"
import style0 from "./HospitalNewDeparmentEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports